import React from 'react'
import PropTypes from 'prop-types'
import { path } from 'ramda'
import { AwnSwitch } from '../common'
import { Link } from 'react-router-dom'
import './SmsAutoRefillToggle.less'
import classNames from 'classnames'

function SmsAutoRefillToggle ({ user, userActions, flagName = 'useSmsBankMetered' }) {
  const hasCard = !!path(['info', 'payments', 'defaultPaymentMethod'], user)
  const isEnabled = path(['info', flagName], user) || false

  const handleSmsToggle = async () => {
    if (!hasCard) return
    await userActions.patch(user.info._id, { [flagName]: !isEnabled })
  }

  return (
    <div className={classNames('payment-sms-auto-refill-toggle', { 'no-card': !hasCard })}>
      {!hasCard && (
        <p className='sms-toggle-error no-card-error'>
          <Link
            to='/subscriptions/payment'
            onClick={() => {
              userActions.doModal(null)
              setTimeout(() => {
                const element = document.getElementById('payment_details')
                if (element) {
                  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
                  window.scrollTo({
                    top: elementPosition - 160,
                    behavior: 'smooth'
                  })
                }
              }, 100)
            }}
          >Add a valid payment method</Link><br/>to enable SMS auto refill
        </p>
      )}
      {
        hasCard && (
          <>
            <div className='sms-toggle-row'>
              <AwnSwitch
                checked={isEnabled && hasCard}
                onChange={handleSmsToggle}
                disabled={!hasCard}
              />
              <span className='sms-toggle-label'>
                Metered SMS auto-refill*
              </span>
            </div>
            <p className='sms-toggle-disclaimer'>
              * Automatically add 100 SMS ($1.50 per 100 SMS / Monthly billed) when your available messages are depleted.
            </p>
          </>
        )
      }
    </div>
  )
}

SmsAutoRefillToggle.propTypes = {
  user: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired,
  flagName: PropTypes.string
}

SmsAutoRefillToggle.displayName = 'SmsAutoRefillToggle'

export default SmsAutoRefillToggle
